<template>
  <div class="warning-about-index">
    <headerItem titleName="预警说明" :showUp="false" :showRight="false" />
    <div class="warning-about-item">
      <img src="@/assets/wwabout/w01.png" alt="">
      <img src="@/assets/wwabout/w02.png" alt="">
    </div>
  </div>
</template>

<script>
import headerItem from "./components/header";
export default {
  data() {
    return {};
  },
  methods: {},
  components: {
    headerItem,
  },
  created() {
    this.$loading.hide();
  },
};
</script>

<style lang="less" scoped>
.warning-about-index {
  font-size: 24px;
  .warning-about-item {
    background-color: #fff;
    img{
      max-width: 100%;
      object-fit: cover;
      display: block;
    }
   
  }
}
</style>